import React, { useState } from 'react'
import PropTypes from 'prop-types'
import ReportCenterItemBase from './report_center_item_base'
import styled from 'styled-components'
import { getAuthenticityToken } from 'Shared/helpers'
import handleQrBlocks from '../flyer/utils/qr_block_handler'

const StyledFormComponents = styled.div`
  .flyer-header {
    padding: 10px;
    background-color: #ffffff;
    font-size: 16px;
    border: 0.9px solid grey;
    display: flex;
    color: inherit;
    text-decoration: none;
    justify-content: space-between;
    min-height: 60px;
    margin: 10px 24px 0px 24px;
    
    .category-name {
      display: flex;
      align-items: center;
    }

    .caret-display {
      display: flex;
      flex-direction: column-reverse;
      justify-content: center;
      margin-right: 20px;
    }
  }
  
  .flyers-content {
    width: 100%;

    table {
      width: stretch !important;
      margin: 0px 25px 0px 50px;
    }
  }

`

const ReportCenterFlyersList = (props) => {
  const [ hideCategory, setHideCategory ] = useState(props.showCategory)
  const [ downloadingState, setDownloadingState ] = useState({})

  const toggleShow = () => {
    setHideCategory(!hideCategory)
  }

  const handleFlyerDelete = (deleteFlyer, isSystemTemplate) => {
    // eslint-disable-next-line no-alert
    if (confirm(window.I18n.t('views.golfhub.remove_flyer_confirmation_message'))){
      fetch(`/leagues/${props.leagueId}/flyers?flyer_id=${deleteFlyer.id}&is_system_template=${isSystemTemplate}`, {
        method: 'DELETE',
        headers: {'X-CSRF-Token': getAuthenticityToken()},
      })
      .then(() => {
        const newFlyers = props.flyers.filter((flyer) => flyer.id !== deleteFlyer.id)
        props.setFlyers(newFlyers)
      })
    }
  }

  const updateFlyerLog = async (description) => {
    const params = {
      desc: description,
      league_id: props.leagueId,
    }

    return fetch(`/leagues/${props.leagueId}/flyers/create_flyer_log`, {
      method: 'POST',
      headers: 
      {
        'X-CSRF-Token': getAuthenticityToken(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    })
  }

  const convertToBlob = async (clause, scene) => {
    // eslint-disable-next-line no-useless-catch
    try {
      const mimePdfOrPng = clause === 'pdf' ? 'application/pdf' : 'image/png'

      return await props.imglyInstance.engine.block.export(scene, { mimeType: mimePdfOrPng })
    } catch (error) {
      throw error
    }
  }

  const setDownloadText = (flyerId, clause, value) => {
    setDownloadingState(prev => ({
      ...prev,
      [flyerId]: {
        ...prev[flyerId],
        [clause]: value,
      },
    }))
  }

  const getStringFromFlyerId = async (leagueId, predefined) => {
    if (predefined !== null) {
      return new Promise((resolve, reject) => {
        $.ajax({
          url: `/leagues/${leagueId}/flyers/string_from_flyer_id?flyer_id=${predefined}&is_system_template=false`,
          type: 'GET',
          success: (data) => {
            resolve(data)
          },
          error: (error) => {
            reject(error)
          },
        })
      })
    } else {
      return new Promise.resolve(null)
    }
  }

  const getSceneFromString = async (clause, flyerId) => {
    try {
      const sceneStringPromise = getStringFromFlyerId(props?.leagueId, flyerId)
      const sceneStringData = await sceneStringPromise

      await props.imglyInstance.engine.scene.loadFromString(sceneStringData)

      handleQrBlocks(props.imglyInstance.engine, {
        isRosterLeague: props.isRosterLeague,
        isPagePublished: props.isPagePublished,
        qrImageUrl: props.qrImageUrl,
      })

      const scenes = clause === 'pdf' ? [ await props.imglyInstance.engine.scene.get() ] : await props.imglyInstance.engine.scene.getPages()

      return scenes
    } catch (error) {
      return false
    }
  }

  const printFlyer = async (flyerId, clause, event) => {
    setDownloadText(flyerId, clause, true)
    const scenes = await getSceneFromString(clause, flyerId)

    if (scenes !== false) {
      scenes.forEach(async (scene) => {
        try {
          await convertToBlob(clause, scene).then(blob => {
            const anchor = document.createElement('a')
            anchor.href = URL.createObjectURL(blob)
            anchor.download = `flyer.${clause === 'pdf' ? 'pdf' : 'png'}`
            anchor.click()
          })
        } catch (error) {
          window.show_flash(window.I18n.t('views.golfhub.error_download_flyer'))
          window.hide_flash()
        }
      })

      event.preventDefault()
      await updateFlyerLog(window.I18n.t('views.golfhub.flyer_stats.print_flyer'))
    } else {
      window.show_flash(window.I18n.t('views.golfhub.error_download_flyer'))
      window.hide_flash()
    }

    setDownloadText(flyerId, clause, false)
  }

  return (
    <StyledFormComponents>
      {props.layout === 'block' ? (
        <>
          <div className="flyer-header" onClick={() => toggleShow()}>
              <div className="category-name">
                {props.isSystemFlyer ? window.I18n.t('views.golfhub.templates') : window.I18n.t('views.golfhub.flyers')}
              </div>
              <div className="caret-display">
                <i className={`fa ${hideCategory ? 'fa-caret-up' : 'fa-caret-down'}`}></i>
              </div>
            </div>
          { hideCategory && 
            <div className="flyers-content">
              {props.flyers.length > 0 ? (
                <table className="table table_with_dropdown">
                  <thead>
                    <tr>
                      <th className=""></th>
                      <th className="text-right add-padding-right-30" colSpan="4"><strong>{!window.I18n ? '' : window.I18n.t('download_center.report_center_list.actions')}</strong></th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      props.flyers.map((reportCenterItem, _index) => (
                        <ReportCenterItemBase 
                          key={props.reportCenterList.id + '_' + reportCenterItem.id + '_' + _index}
                          report_center_lists={props.reportCenterLists}
                          report_center_item={ reportCenterItem }
                          current_report_center_list={props.currentReportCenterList}
                          openPrintModal={props.openPrintModal}
                          index={_index}
                          league_id={props.leagueId}
                          layout={props.layout}
                          mode="download_center"
                          isTeamCaptain={props.isTeamCaptain}
                          toggleArchiveItem={props.toggleArchiveItem}
                          cloneItem={props.cloneItem}
                          addRemoveItemToList={props.addRemoveItemToList}
                          handleFlyerDelete={() => handleFlyerDelete(reportCenterItem, reportCenterItem.system_flyer)}
                          printFlyer={printFlyer}
                          downloadingState={downloadingState}
                          roundId={props.roundId}
                        />
                      ))
                    }
                  </tbody>
                </table>
              ) : (
                <div className="no_results_found">
                  { window.I18n.t('views.golfhub.no_results_found') }
                </div>
              )}
            </div>
          }
        </>
      ) : (
        <div className="flyers">
          <div className="flyer-header" onClick={() => toggleShow()}>
            <div className="category-name">
              {props.isSystemFlyer ? window.I18n.t('views.golfhub.templates') : window.I18n.t('views.golfhub.flyers')}
            </div>
            <div className="caret-display">
              <i className={`fa ${hideCategory ? 'fa-caret-up' : 'fa-caret-down'}`}></i>
            </div>
          </div>
          { hideCategory && 
            <div className="flyers-content">
              <div className="col-sm-12 inline">
                { props.flyers.length > 0 ? (
                    props.flyers.map((reportCenterItem, _index) => (
                      <ReportCenterItemBase 
                        key={props.reportCenterList.id + '_' + reportCenterItem.id + '_' + _index}
                        report_center_lists={props.reportCenterLists}
                        report_center_item={ reportCenterItem }
                        current_report_center_list={props.currentReportCenterList}
                        openPrintModal={props.openPrintModal}
                        index={_index}
                        league_id={props.leagueId}
                        layout={props.layout}
                        mode="download_center"
                        isTeamCaptain={props.isTeamCaptain}
                        toggleArchiveItem={props.toggleArchiveItem}
                        cloneItem={props.cloneItem}
                        addRemoveItemToList={props.addRemoveItemToList}
                        handleFlyerDelete={() => handleFlyerDelete(reportCenterItem, reportCenterItem.system_flyer)}
                        printFlyer={printFlyer}
                        downloadingState={downloadingState}
                        roundId={props.roundId}
                      />
                    )))
                  : (
                    <div className="no_results_found">
                      { window.I18n.t('views.golfhub.no_results_found') }
                    </div>
                  )
                }
              </div>
            </div>
          }
        </div>
      )}
    </StyledFormComponents>
  )
}

ReportCenterFlyersList.propTypes = {
  isSystemFlyer: PropTypes.bool.isRequired,
  flyers: PropTypes.array.isRequired,
  setFlyers: PropTypes.func.isRequired,
  reportCenterList: PropTypes.object.isRequired,
  reportCenterLists: PropTypes.array.isRequired,
  currentReportCenterList: PropTypes.object.isRequired,
  openPrintModal: PropTypes.func.isRequired,
  leagueId: PropTypes.string,
  layout: PropTypes.string.isRequired,
  mode: PropTypes.string.isRequired,
  isTeamCaptain: PropTypes.bool.isRequired,
  toggleArchiveItem: PropTypes.func.isRequired,
  showCategory: PropTypes.bool.isRequired,
  cloneItem: PropTypes.func.isRequired,
  addRemoveItemToList: PropTypes.func.isRequired,
  imglyInstance: PropTypes.object,
  roundId: PropTypes.string,
  isPagePublished: PropTypes.bool,
  qrImageUrl: PropTypes.string,
  isRosterLeague: PropTypes.bool,
}

export default ReportCenterFlyersList
